import Swiper from 'swiper';

const $this = $('.js-slider-categories');

if ($this.length) {

  new Swiper('.js-slider-categories.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.js-next-category',
      prevEl: '.js-prev-category',
    },
    breakpointsInverse: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
      }
    }
  });
}